module.exports = __webpack_public_path__ + "img/AQ.f807139b.svg";